module.exports = __webpack_public_path__ + "artem.d8031d4c1eabc87c223a.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/assets/employees/artem.jpg
// module id = ../../../../../src/assets/employees/artem.jpg
// module chunks = 0